'use client'

import { create } from 'zustand'

import type { PaymentOrder } from '@/features/veluvit/schemas/payment.schema'

export type PopupPayment = {
  id: string
  ownerId: string
  identity: number
  popup: Window
  order: PaymentOrder
  closed: boolean
  busy: boolean
  error: string | null
  walletError: string | null
  check?: () => Promise<void>
  refreshWallet?: () => Promise<void>
}

type PopupState = {
  payments: Record<string, PopupPayment>
  add: (payment: PopupPayment) => void
  update: (orderId: string, id: string, patch: Partial<PopupPayment>) => void
  remove: (orderId: string, id: string) => void
}

export const usePaymentPopupStore = create<PopupState>()((set) => ({
  payments: {},
  add: (payment) =>
    set((state) => ({
      payments: { ...state.payments, [payment.order.id]: payment },
    })),
  update: (orderId, id, patch) =>
    set((state) => {
      const current = state.payments[orderId]
      if (
        !current ||
        current.id !== id ||
        Object.entries(patch).every(([key, value]) =>
          Object.is(current[key as keyof PopupPayment], value)
        )
      )
        return state
      return {
        payments: { ...state.payments, [orderId]: { ...current, ...patch } },
      }
    }),
  remove: (orderId, id) =>
    set((state) => {
      if (state.payments[orderId]?.id !== id) return state
      const payments = { ...state.payments }
      delete payments[orderId]
      return { payments }
    }),
}))
